<template>
  <div :class="{'d-flex' : showAvatar || !isMe, 'd-flex justify-content-end': (!showAvatar && isMe)||(showAvatar && isMe)}">
    <img v-if="!isMe && showAvatar" :src="globalData.setting?.live_chat?.avatar" alt="" class="avatar-content"/>
    <div v-else class="non-avatar"></div>
    <div :class="cls" v-b-tooltip="{ title: util.formatTime(msg.created_at), placement: isMe ? 'left' : 'right' }">
      <span style="word-wrap:break-word" v-html="regex_URL(escapeHTML(msg.message.content.message))"></span>
    </div>
  </div>
</template>

<script>
import util from "@/lib/util";
export default {
  name: 'MsgText',
  computed: {
    util() {
      return util
    }
  },
  components: {},
  props: ['msg', 'cls', 'isMe', 'showAvatar'],
  created() {
  },
  data() {
    return {}
  },

  methods: {
     escapeHTML(str) {
      const div = document.createElement('div');
      div.innerText = str;
      return div.innerHTML;
    },

    regex_URL(message) {
      let urlRegex = /(((https?:\/\/)|(www\.))\S+)/g;
      if (message && message.length > 0) {
        return message.replace(urlRegex, function (url, b, c) {
          let url2 = (c === 'www.') ? `https://${url}` : url;
          return `<a class="text-link" href="${url2}" target="_blank">${url}</a>`
        })
      }
    },
  }

};
</script>

<style lang="scss" scoped>
</style>